<fieldset [formGroup]="parentFormGroup">
  <legend>
    <div>
      <span i18n>Bookable option</span>
    </div>
  </legend>
  <p i18n>
    Name of the option the user will see when booking.
  </p>
  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label i18n>Name</mat-label>
      <input matInput id="name" type="text" formControlName="name">
    </mat-form-field>
  </div>
</fieldset>
